import { styled } from 'styled-components'
import { alpha } from '@mui/material'
import { onMediumScreen } from 'mixtiles-web-common'

export const Container = styled.div`
  margin-bottom: 28px;
  animation: scale-up-center 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;

  @keyframes scale-up-center {
    0% {
      transform: scale(0.5);
    }
    100% {
      transform: scale(1);
    }
  }
`

export const Message = styled.div`
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  border: 1px solid ${({ theme }) => theme.colors.errorRed};
  padding: 12px 16px;
  box-sizing: border-box;
  border-radius: 5px;
  margin: 0 auto;
  background-color: ${({ theme }) => alpha(theme.colors.errorRed, 0.15)};
  white-space: pre-line;

  ${onMediumScreen()} {
    max-width: 510px;
  }
`
